// Quantity popover + "trash-at-1" adfærd til Dawn cart
if (!customElements.get("quantity-popover")) {
  customElements.define(
    "quantity-popover",
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();

        this.mql = window.matchMedia("(min-width: 990px)");
        this.mqlTablet = window.matchMedia("(min-width: 750px)");

        this.infoButtonDesktop = this.querySelector(
          ".quantity-popover__info-button--icon-only"
        );
        this.infoButtonMobile = this.querySelector(
          ".quantity-popover__info-button--icon-with-label"
        );
        this.popoverInfo = this.querySelector(".quantity-popover__info");
        this.closeButton = this.querySelector(".button-close");
        this.eventMouseEnterHappened = false;

        // --- Quantity refs
        this.qtyWrapper = this.querySelector(".quantity.cart-quantity");
        this.qtyInput = this.querySelector(".quantity__input");
        this.minusBtn = this.querySelector('.quantity__button[name="minus"]');
        this.plusBtn = this.querySelector('.quantity__button[name="plus"]');

        this.updateMinusIcon();

        if (this.qtyInput) {
          this.qtyInput.addEventListener(
            "input",
            this.updateMinusIcon.bind(this)
          );
          this.qtyInput.addEventListener(
            "change",
            this.updateMinusIcon.bind(this)
          );
        }

        // Overtag "minus" tidligt: kun når qty==1 fjernes linjen via CartItems API
        if (this.minusBtn && this.qtyInput) {
          const interceptRemove = (e) => {
            if (this.minusBtn.disabled || this.qtyInput.disabled) return;

            const current = parseInt(this.qtyInput.value || "0", 10);
            if (isNaN(current)) return;

            if (current === 1) {
              // Overtag: fjern linjen via CartItems API (ikke via 0 + change)
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation?.();

              // De-dup: dette kører på både pointerdown OG click, så ét fysisk
              // klik ellers ville sende to fjern-kald (det andet rammer en
              // allerede-fjernet linje). Lås kortvarigt, så det andet event ignoreres.
              if (this._removeInFlight) return;
              this._removeInFlight = true;
              setTimeout(() => {
                this._removeInFlight = false;
              }, 1000);

              const index = this.qtyInput.dataset.index; // <-- sat i Liquid: data-index="{{ item.index | plus: 1 }}"
              const variantId = this.qtyInput.dataset.quantityVariantId;
              const key = this.qtyInput.dataset.key; // line item key — stabil ift. positions-index

              const cartItems =
                this.closest("cart-items") ||
                this.closest("cart-drawer-items") ||
                document.querySelector("cart-drawer-items, cart-items");

              if (cartItems && typeof cartItems.updateQuantity === "function") {
                cartItems.updateQuantity(index, 0, e, "minus", variantId, key);
              }
              return;
            }

            // Ellers (current > 1): lad Dawn's egen minus-logik køre uændret
          };

          // Fang før themes egne click handlers:
          this.minusBtn.addEventListener("pointerdown", interceptRemove, {
            capture: true,
          });
          this.minusBtn.addEventListener("click", interceptRemove, {
            capture: true,
          });
        }

        if (this.closeButton) {
          this.closeButton.addEventListener(
            "click",
            this.closePopover.bind(this)
          );
        }
        if (
          this.popoverInfo &&
          this.infoButtonDesktop &&
          this.mqlTablet.matches
        ) {
          this.popoverInfo.addEventListener(
            "mouseleave",
            this.closePopover.bind(this)
          );
        }
        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener(
            "click",
            this.togglePopover.bind(this)
          );
          this.infoButtonDesktop.addEventListener(
            "focusout",
            this.closePopover.bind(this)
          );
          if (this.mqlTablet.matches) {
            this.infoButtonDesktop.addEventListener(
              "mouseenter",
              this.togglePopover.bind(this)
            );
            this.infoButtonDesktop.addEventListener(
              "mouseleave",
              this.closePopover.bind(this)
            );
          }
        }
        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener(
            "click",
            this.togglePopover.bind(this)
          );
        }
      }

      updateMinusIcon() {
        if (!this.qtyWrapper || !this.qtyInput) return;
        const q = parseInt(this.qtyInput.value || "0", 10);
        const isOne = q === 1;
        this.qtyWrapper.classList.toggle("is-one", isOne);

        const sr = this.minusBtn?.querySelector(".visually-hidden");
        if (sr) {
          sr.textContent = isOne
            ? this.dataset.ariaRemove || "Remove item"
            : this.dataset.ariaDecrease || "Decrease quantity";
        }
      }

      togglePopover(event) {
        if (!event) return;
        event.preventDefault();
        if (event.type === "mouseenter") this.eventMouseEnterHappened = true;
        if (event.type === "click" && this.eventMouseEnterHappened) return;

        const button =
          this.infoButtonDesktop && this.mql.matches
            ? this.infoButtonDesktop
            : this.infoButtonMobile;
        if (!button || !this.popoverInfo) return;

        const isExpanded = button.getAttribute("aria-expanded") === "true";
        if ((this.mql.matches && !isExpanded) || event.type === "click") {
          button.setAttribute("aria-expanded", (!isExpanded).toString());
          this.popoverInfo.toggleAttribute("hidden");
          button.classList.toggle("quantity-popover__info-button--open");
          this.infoButtonDesktop?.classList.add(
            "quantity-popover__info-button--icon-only--animation"
          );
        }

        const isOpen = button.getAttribute("aria-expanded") === "true";
        if (isOpen && event.type !== "mouseenter") {
          button.focus();
          button.addEventListener(
            "keyup",
            (e) => {
              if (e.key === "Escape") this.closePopover(e);
            },
            { once: true }
          );
        }
      }

      closePopover(event) {
        if (!event) return;
        event.preventDefault();
        const button =
          this.infoButtonDesktop && this.mql.matches
            ? this.infoButtonDesktop
            : this.infoButtonMobile;
        if (!button || !this.popoverInfo) return;

        const related = event.relatedTarget || null;
        const isButtonChild =
          this.infoButtonDesktop && related
            ? this.infoButtonDesktop.contains(related)
            : false;
        const isPopoverChild =
          this.popoverInfo && related
            ? this.popoverInfo.contains(related)
            : false;

        if (!isButtonChild && !isPopoverChild) {
          button.setAttribute("aria-expanded", "false");
          button.classList.remove("quantity-popover__info-button--open");
          this.popoverInfo.setAttribute("hidden", "");
          this.infoButtonDesktop?.classList.remove(
            "quantity-popover__info-button--icon-only--animation"
          );
        }
        this.eventMouseEnterHappened = false;
      }
    }
  );
}
